import { defineMessages } from 'react-intl';

const messages = defineMessages({
  helperText: {
    id: 'App.ManageGrossRents.GrossRentChanges.helperText',
    defaultMessage:
      'Expand a Gross Rent change to review the details and affected floor plans based on the Effective Date.',
  },
  effectiveDateLabel: {
    id: 'App.ManageGrossRents.GrossRentChanges.effectiveDateLabel',
    defaultMessage: 'Effective Date: {date}',
  },
  voucherDateLabel: {
    id: 'App.ManageGrossRents.GrossRentChanges.voucherDateLabel',
    defaultMessage: 'Voucher Date: {date}',
  },
  edit: {
    id: 'App.ManageGrossRents.GrossRentChanges.edit',
    defaultMessage: 'Edit',
  },
  delete: {
    id: 'App.ManageGrossRents.GrossRentChanges.delete',
    defaultMessage: 'Delete',
  },
  lockedChangeTooltip: {
    id: 'App.ManageGrossRents.GrossRentChanges.lockedChangeTooltip',
    defaultMessage:
      'Certifications have already been completed for this change.',
  },
  floorPlan: {
    id: 'App.ManageGrossRents.GrossRentChanges.floorPlan',
    defaultMessage: 'Floor Plan',
  },
  bedsBath: {
    id: 'App.ManageGrossRents.GrossRentChanges.bedsBath',
    defaultMessage: 'Beds / Bath',
  },
  grossRent: {
    id: 'App.ManageGrossRents.GrossRentChanges.grossRent',
    defaultMessage: 'Gross Rent',
  },
  utilityAllowance: {
    id: 'App.ManageGrossRents.GrossRentChanges.utilityAllowance',
    defaultMessage: 'Utility Allowance',
  },
  createdOn: {
    id: 'App.ManageGrossRents.GrossRentChanges.createdOn',
    defaultMessage: 'Created On',
  },
  createdBy: {
    id: 'App.ManageGrossRents.GrossRentChanges.createdBy',
    defaultMessage: 'Created By',
  },
  deleteGrossRentChangeModalTitle: {
    id: 'App.ManageGrossRents.GrossRentChanges.deleteGrossRentChangeModalTitle',
    defaultMessage: 'Delete Gross Rent',
  },
  deleteGrossRentChangeModalBodyIntro: {
    id: 'App.ManageGrossRents.GrossRentChanges.deleteGrossRentChangeModalBodyIntro',
    defaultMessage:
      'Are you sure you want to delete this Gross Rent change for {effectiveDate}?',
  },
  deleteGrossRentChangeWarningBannerTitle: {
    id: 'App.ManageGrossRents.GrossRentChanges.deleteGrossRentChangeWarningBannerTitle',
    defaultMessage: 'Deleting this change will:',
  },
  deleteGrossRentChangeWarningBannerBulletFloorPlans: {
    id: 'App.ManageGrossRents.GrossRentChanges.deleteGrossRentChangeWarningBannerBulletFloorPlans',
    defaultMessage:
      'Remove the Gross Rent change and/or Utility Allowance amounts ' +
      'for the floor plans and set them back to the previous amounts',
  },
  deleteGrossRentChangeWarningBannerBulletCertifications: {
    // eslint-disable-next-line max-len
    id: 'App.ManageGrossRents.GrossRentChanges.deleteGrossRentChangeWarningBannerBulletCertifications',
    defaultMessage:
      'Delete all Gross Rent Certifications created from this change',
  },
  deleteGrossRentChangeInProgressTitle: {
    id: 'App.ManageGrossRents.GrossRentChanges.deleteGrossRentChangeInProgressTitle',
    defaultMessage: 'In Progress',
  },
  deleteGrossRentChangeInProgressMessage: {
    id: 'App.ManageGrossRents.GrossRentChanges.deleteGrossRentChangeInProgressMessage',
    defaultMessage: 'Deleting the Gross Rent change is in progress.',
  },
  deleteGrossRentChangeSuccess: {
    id: 'App.ManageGrossRents.GrossRentChanges.deleteGrossRentChangeSuccess',
    defaultMessage: 'Gross Rent change deleted successfully',
  },
  errorDeletingGrossRentChange: {
    id: 'App.ManageGrossRents.GrossRentChanges.errorDeletingGrossRentChange',
    defaultMessage:
      'There was an error deleting the Gross Rent change: {errorMessage}',
  },
  errorLoading: {
    id: 'App.ManageGrossRents.GrossRentChanges.errorLoading',
    defaultMessage: 'Error loading gross rent changes',
  },
  loadError: {
    id: 'App.ManageGrossRents.GrossRentChanges.loadError',
    defaultMessage: 'Unable to load gross rent changes. Please try again.',
  },
  retry: {
    id: 'App.ManageGrossRents.GrossRentChanges.retry',
    defaultMessage: 'Try again',
  },
});

export default messages;
